import PropTypes, { bool } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { Input, Label } from "./Styles";

StreetField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.oneOf(["on", "off"]),
  style: PropTypes.object,
  disabled: bool,
};

export function StreetField({
  value = "",
  onChange,
  label = "Address",
  name = "street",
  placeholder = "Street",
  hideInternalFocusStyles = false,
  autoComplete = "off",
  style,
  disabled,
}) {
  return (
    <Wrapper style={style}>
      <Label htmlFor={name}>{label}</Label>
      <Input
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        hideInternalFocusStyles={hideInternalFocusStyles}
        autoComplete={autoComplete}
        disabled={disabled}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  flex-grow: 1;
`;
